import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  FormFeedback,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from 'reactstrap';
import SelectAPI from './SelectAPI';
import Strings from '../strings/Strings';
import BaseService from '../services/BaseService';
import Loader from './Loader';
import Geocode from "react-geocode";
import GoogleMapReact from 'google-map-react';
import Pin from './Pin.jsx';

class ParkingSpotCreate extends React.Component{
  constructor(props){
    super(props)
    this.state = {
      spot_number: '',
      spotNumberInvalid: false,
      address: '',
      addressInvalid: false,
      city: null,
      cityInvalid: false,
      state: null,
      stateInvalid: false,
      address_number: '',
      addressNumberInvalid: false,
      sector: '',
      sectorInvalid: false,
      spot_type: null,
      spotTypeInvalid: false,
      status: '',
      statusInvalid: false,
      loading: false,
      error_message: "",
      color_message: "",
      latitude: 0,
      longitude: 0
    };

    // Get position
    if('geolocation' in navigator){
      const refThis = this
      navigator.geolocation.getCurrentPosition(
        function(position){
          if( position.coords.latitude !== 0 && position.coords.longitude !== 0 ){
            refThis.setState({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            });
          }
        },
        function(error){
          console.log(error);
        }
      );
    }

    this.handleInputChange = this.handleInputChange.bind(this);
    this.toggle = this.toggle.bind(this);
    this.valid_field = this.valid_field.bind(this);
    this.register = this.register.bind(this);
    this.sleep = this.sleep.bind(this);
    this.get_latitude_longitude = this.get_latitude_longitude.bind(this);
    Geocode.setApiKey(BaseService.KeyGoogleMap);
  }

  // dispatching an action based on state change
  componentWillUpdate(nextProps, nextState) {
   if (nextProps.editing !== null && nextProps.editing !== this.props.editing) {
     console.log(nextProps.editing)
      this.setState({
        spot_number: nextProps.editing.spot_number,
        address: nextProps.editing.address,
        address_number: nextProps.editing.address_number,
        state: nextProps.editing.city.state,
        city: nextProps.editing.city,
        sector: nextProps.editing.sector,
        spot_type: nextProps.editing.type,
        latitude: nextProps.editing.latitude,
        longitude: nextProps.editing.longitude,
        status: nextProps.editing.status
      })
    }
  }
  handleInputChange (event) {
    // get target
    const target = event.target;
    // if checkbox or input field
    const value = target.type === 'checkbox' ? target.checked: target.value;
    // get tag name
    const name = target.name;
    // Set state
    this.setState({
      [name]: value
    });
  }
  toggle(refresh){
    if('geolocation' in navigator){
      const refThis = this
      navigator.geolocation.getCurrentPosition(
        function(position){
          if( position.coords.latitude !== 0 && position.coords.longitude !== 0 ){
            refThis.setState({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            });
          }
        },
        function(error){
          console.log(error);
        }
      );
    }
    this.setState({
      spot_number: '',
      spotNumberInvalid: false,
      address: '',
      addressInvalid: false,
      city: null,
      cityInvalid: false,
      state: null,
      stateInvalid: false,
      address_number: '',
      addressNumberInvalid: false,
      sector: '',
      sectorInvalid: false,
      spot_type: null,
      spotTypeInvalid: false,
      status: '',
      statusInvalid: false,
      loading: false,
      error_message: "",
      color_message: "",
      latitude: 0,
      longitude: 0
    });
    this.props.toggle(refresh);
  }
  get_latitude_longitude(){
    var invalid = false;
    if (this.state.address.length<=6 || this.state.address.length>100) {
      invalid = true;
      this.setState({addressInvalid: true});
    } else {
      this.setState({addressInvalid: false});
    }
    if (this.state.address_number.length<=0 || this.state.address.length>100000) {
      invalid = true;
      this.setState({addressNumberInvalid: true});
    } else {
      this.setState({addressNumberInvalid: false});
    }
    if (this.state.state===null || this.state.state.length<=0) {
      invalid = true;
      this.setState({stateInvalid: true});
    } else {
      this.setState({stateInvalid: false});
    }
    if (this.state.city===null || this.state.city.length<=0){
      invalid = true;
      this.setState({cityInvalid: true});
    } else {
      this.setState({cityInvalid: false});
    }

    // Valid inputs
    if(invalid===true){
      return false;
    }

    // Search geocode
    Geocode.fromAddress(this.state.address+', '+this.state.address_number+' - '+this.state.city.name+' - '+this.state.state.name).then(
      response => {
        const { lat, lng } = response.results[0].geometry.location;
        this.setState({
          latitude: lat,
          longitude: lng
        });
      },
      error => {
        console.error(error);
      }
    );
  }
  sleep(milliseconds){
    return new Promise(resolve => setTimeout(resolve, milliseconds))
  }
  valid_field(){
    var invalid = false;
    if (this.state.spot_number.length<=0 || this.state.spot_number.length>10) {
      invalid = true;
      this.setState({spotNumberInvalid: true});
    } else {
      this.setState({spotNumberInvalid: false});
    }
    if (this.state.address.length<=6 || this.state.address.length>100) {
      invalid = true;
      this.setState({addressInvalid: true});
    } else {
      this.setState({addressInvalid: false});
    }
    if (this.state.address_number.length<=0 || this.state.address_number>100000) {
      invalid = true;
      this.setState({addressNumberInvalid: true});
    } else {
      this.setState({addressNumberInvalid: false});
    }
    if (this.state.sector===null || this.state.sector.length<=0) {
      invalid = true;
      this.setState({sectorInvalid: true});
    } else {
      this.setState({sectorInvalid: false});
    }
    if (this.state.spot_type===null || this.state.spot_type.length<=0) {
      invalid = true;
      this.setState({spotTypeInvalid: true});
    } else {
      this.setState({spotTypeInvalid: false});
    }
    if (this.state.state===null || this.state.state.length<=0) {
      invalid = true;
      this.setState({stateInvalid: true});
    } else {
      this.setState({stateInvalid: false});
    }
    if (this.state.city===null || this.state.city.length<=0){
      invalid = true;
      this.setState({cityInvalid: true});
    } else {
      this.setState({cityInvalid: false});
    }
   
    if(invalid===false){
      Geocode.fromAddress(
        this.state.address+', '+this.state.address_number+' - '+this.state.city.name+' - '+this.state.state.name
      ).then(
        response => {
          const { lat, lng } = response.results[0].geometry.location;
          this.setState({
            latitude: lat,
            longitude: lng
          });
        },
        error => {
          console.error(error);
        }
      );
    }

    if(this.props.editing !== null){
      if (this.state.status===null || this.state.status.length<=0) {
        invalid = true;
        this.setState({statusInvalid: true});
      } else {
        this.setState({statusInvalid: false});
      }
    }

    // Valid inputs
    if(invalid===true){
      return false;
    }

    // Success
    return true;
  }
  register() {
    if(!this.valid_field()){
      return; 
    }

    this.sleep(1000).then(() => {
      this.setState({loading: true});
      let url = BaseService.ENDPOINT + 'admin/parking-spot';
      var msg_success = 'cadastrada';
      var form = new FormData();
      form.append("spot_number", this.state.spot_number);
      form.append("address", this.state.address);
      form.append("address_number", this.state.address_number);
      form.append("city", this.state.city.id);
      form.append("latitude", this.state.latitude);
      form.append("longitude", this.state.longitude);
      form.append("sector", this.state.sector);
      form.append("spot_type", this.state.spot_type.id);
      if(this.props.editing !== null){
        url += "/"+this.props.editing.id;
        form.append("status", this.state.status.id);
        msg_success = 'alterada';
      }
      return fetch(url, {
        method: 'POST',
        headers: new Headers({
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + this.props.user.access_token,
        }),
        body: form
      })
      .then((response) => response.json())
      .then((json) => {
        if(json.return.code === 1){
          this.setState({
            loading: true,
            error_message: 'Vaga '+msg_success+' com sucesso!',
            color_message: 'success'
          });
        } else if(json.return.code >= 300){
          window.location = '/';
        } else {
          this.setState({
            loading: true,
            error_message: json.return.message
          });
        }
      });
    });
  }
  render() {
    let SelectAPIStatus = '';
    if(this.props.editing !== null){
      SelectAPIStatus = 
        <SelectAPI
          label={(this.props.editing!==null?Strings.status:'')}
          name="status"
          placeholder={"Selecione um "+Strings.status}
          access_token={this.props.user.access_token}
          api="admin/parking-spot-status"
          selectedOption={this.handleInputChange}
          value={this.state.status}
          invalid={this.state.statusInvalid} 
          formFeedbackMsg={Strings.required_field}
          multi={false}
        />
    }
    return (
      <Modal isOpen={this.props.visible} >
        <ModalHeader>{(this.props.editing!==null?'Editar':'Nova')} Vaga</ModalHeader>
          <ModalBody hidden={this.state.loading}>
            <Form>
              <FormGroup>
                {(this.props.editing!==null?<Label>Número da Vaga</Label>:'')}
                <Input
                  type="text"
                  maxLength={100}
                  name="spot_number"
                  placeholder="Número da Vaga"
                  value={this.state.spot_number}
                  onChange={this.handleInputChange}
                  invalid={this.state.spotNumberInvalid}>
                </Input>
                <FormFeedback>{Strings.required_field}</FormFeedback>
              </FormGroup>
              <FormGroup>
                {(this.props.editing!==null?<Label>Endereço</Label>:'')}
                <Input
                  type="text"
                  maxLength={100}
                  name="address"
                  placeholder="Endereço"
                  value={this.state.address}
                  onChange={this.handleInputChange}
                  invalid={this.state.addressInvalid}>
                </Input>
                <FormFeedback>{Strings.required_field}</FormFeedback>
              </FormGroup>
              <FormGroup>
                {(this.props.editing!==null?<Label>Número</Label>:'')}
                <Input
                  type="text"
                  maxLength={100}
                  name="address_number"
                  placeholder="Número"
                  value={this.state.address_number}
                  onChange={this.handleInputChange}
                  invalid={this.state.addressNumberInvalid}>
                </Input>
                <FormFeedback>{Strings.required_field}</FormFeedback>
              </FormGroup>
              <FormGroup>
                {(this.props.editing!==null?<Label>Setor</Label>:'')}
                <Input
                  type="int"
                  maxLength={100}
                  name="sector"
                  placeholder="Setor"
                  value={this.state.sector}
                  onChange={this.handleInputChange}
                  invalid={this.state.sectorInvalid}>
                </Input>
                <FormFeedback>{Strings.required_field}</FormFeedback>
              </FormGroup>
              {SelectAPIStatus}
              <SelectAPI
                label={(this.props.editing!==null ? Strings.spot_type : '')}
                name="spot_type"
                placeholder={"Selecione um "+Strings.spot_type}
                access_token={this.props.user.access_token}
                api="admin/spot-type"
                selectedOption={this.handleInputChange}
                value={this.state.spot_type}
                invalid={this.state.spotTypeInvalid} 
                formFeedbackMsg={Strings.required_field}
                multi={false}
              />
              <SelectAPI
                label={(this.props.editing!==null?Strings.state:'')}
                name="state"
                placeholder={"Selecione um "+Strings.state}
                access_token={this.props.user.access_token}
                api="admin/states"
                selectedOption={this.handleInputChange}
                value={this.state.state}
                invalid={this.state.stateInvalid} 
                formFeedbackMsg={Strings.required_field}
                multi={false}
              />
              <SelectAPI
                label={(this.props.editing!==null?Strings.city:'')}
                hidden={!(this.state.state !== "")}
                name="city" 
                placeholder={"Selecione uma "+Strings.city}
                access_token={this.props.user.access_token}
                api={"admin/cities/"+(this.state.state==null?'':this.state.state.id)}
                selectedOption={this.handleInputChange}
                value={this.state.city}
                invalid={this.state.cityInvalid} 
                formFeedbackMsg={Strings.required_field}
                multi={false}
              />
              <center>
                <Button
                  outline
                  color="secondary"
                  style={{ marginBottom: '10px' }}
                  onClick={this.get_latitude_longitude}
                >Carregar Endereço no Mapa</Button>
              </center>
              <div style={{height: '50vH', width: '100%'}}>
                <GoogleMapReact
                  bootstrapURLKeys={{key: BaseService.KeyGoogleMap}}
                  defaultZoom={this.props.zoom ? this.props.zoom: 15}
                  center={
                    {lat: this.state.latitude, lng: this.state.longitude}
                  }
                  >
                  <Pin
                    lat={this.state.latitude}
                    lng={this.state.longitude}
                    text={''}
                  />
                </GoogleMapReact>
              </div>
            </Form>
          </ModalBody>
          <Loader
            body={ModalBody}
            hidden={!this.state.loading}
            message={this.state.error_message}
            color_message={this.state.color_message}
            onClose={() => this.setState({loading: false, error_message: '', color_message: ''})}
            onCloseSuccess={() => {this.toggle(true); this.setState({loading: false, error_message: '', color_message: ''});}}
          />
          <ModalFooter hidden={this.state.loading} >
            <Button outline color="secondary" onClick={this.register}>Salvar</Button>
            <Button outline color="danger" onClick={() => this.toggle(false)}>Cancelar</Button>
        </ModalFooter>
    </Modal>
    )
  }
}
export default ParkingSpotCreate;


// WEBPACK FOOTER //
// ./src/components/ParkingSpotCreate.js